"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _zendesk = require("../../redux/modules/zendesk");

var _contactUsFormValidation = require("../../utils/contactUsFormValidation");

var _contactUsFormValidation2 = _interopRequireDefault(_contactUsFormValidation);

var _ContactUsPopup = require("./ContactUsPopup");

var _ContactUsPopup2 = _interopRequireDefault(_ContactUsPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactUsPopupContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: "contactUs",
  fields: ["name", "email", "subject", "comments"],
  validate: _contactUsFormValidation2.default
}), _dec2 = (0, _reactRedux.connect)(null, { createTicket: _zendesk.createTicket }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(ContactUsPopupContainer, _React$Component);

  function ContactUsPopupContainer(props) {
    (0, _classCallCheck3.default)(this, ContactUsPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ContactUsPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(ContactUsPopupContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ContactUsPopupContainer, [{
    key: "onSubmitClick",
    value: function onSubmitClick(values) {
      var _this2 = this;

      this.setState({
        message: null,
        error: null
      });

      var email = values.email,
          subject = values.subject,
          name = values.name,
          comments = values.comments;


      var tag = this.props.tag || "regular";

      var custom_fields = [{
        id: "360000990877",
        value: "Contact_Us"
      }];
      return this.props.createTicket({
        email: email,
        comment: comments,
        tag: tag,
        name: name,
        subject: subject,
        custom_fields: custom_fields
      }).then(function () {
        _this2.setState({
          message: "Thank you! We have your feedback. We'll take a look shortly!"
        });
        var isStudio = _this2.props.isStudio;

        if (window && _epicTracking) {
          window.trackEpicIntrection({
            eventCategory: "Forms",
            eventAction: isStudio ? "Studio" : "Contact Us",
            interactionType: "click",
            eventValue: isStudio ? 10000 : 10
          });
        }
      }, function (reason) {
        _this2.setState({
          error: reason.message
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          nameInputProps = _props$fields.name,
          emailInputProps = _props$fields.email,
          subjectInputProps = _props$fields.subject,
          commentsInputProps = _props$fields.comments,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          title = _props.title,
          description = _props.description,
          tag = _props.tag,
          childReference = _props.childReference;


      return _react2.default.createElement(_ContactUsPopup2.default, {
        icon: "/quixel_logo.png",
        nameInputProps: nameInputProps,
        emailInputProps: emailInputProps,
        subjectInputProps: subjectInputProps,
        commentsInputProps: commentsInputProps,
        error: this.state.error,
        message: this.state.message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick),
        title: title,
        description: description,
        tag: tag,
        onChildRef: childReference
      });
    }
  }]);
  return ContactUsPopupContainer;
}(_react2.default.Component)) || _class) || _class);
exports.default = ContactUsPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactUsContainer/ContactUsContainer.jsx
// module id = 1092
// module chunks = 0